<!--
Renders a hidden model feedback form.
Usage:
<button type="button" class="btn btn-primary w-100" data-toggle="modal" data-target="#feedback">Feedback</button>
<FeedbackForm v-if="authenticated" :info="info" />
For regular feedback info is { toId: "toId", fromId: "fromId|x,y" }
For nfc location feedback info format is { src: "nfc|qr", geoLatitude: x, geoLongitude: y }
For nfc booking feedback info format is { src: "nfc|qr", toId: "toId" }
The launch button can also be link.
@author bmk11u
-->
<template>
  <div>
    <ModalPopup id="feedback" title="Feedback">
      <textarea name="feedback" id="feedback" class="w-100" placeholder="Enter feedback here..." maxlength="500" v-model="feedback"></textarea>
      <div class="btn-group w-100 pt-1" role="group" aria-label="Form buttons">
        <button type="button" class="btn btn-primary" v-on:click="sendFeedback" data-dismiss="modal">Send</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
      </div>
    </ModalPopup>
  </div>
</template>

<script>
import axios from 'axios'
import ModalPopup from '@/components/ModalPopup.vue'

export default {
  name: 'FeedbackForm',
  props: ['info'],
  components: {
    ModalPopup
  },
  data () {
    return {
      feedback: null
    }
  },
  methods: {
    // Post feedback back to the server
    sendFeedback () {
      if (this.feedback != null) {
        let payload = this.info
        payload.feedback = this.feedback
        axios.post('/timetable/feedback', payload)
          .then(() => {
            this.feedback = null
          })
      }
    }
  }
}
</script>
